import s from './index.module.css';
import s1 from '../index.module.css';
import Block from '../Block';
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet';
import { useEffect, useMemo, useState } from 'react';
import arrowSelectRight from '../../../../../../images/svg/arrow_select_right.svg';
import classNames from 'classnames';
import Table from './Table';
import Search from "@UI/Search/new";
import { departments as departmentsApi, teams as teamsApi, rolesOrder, classApi, directionAPI, surveyApi, usersAPI } from '@/api';
import { useAddAlert } from "@hooks/useAddAlert";
import Preloader from '@UI/Preloader';
import Button from '@UI/Button';
import { useParams } from 'react-router-dom';
import SaveButton from '@pages/Admin/Mailings/Create/SaveButton';

export const getArrayWithChildren = (array) => {
    const arrayWithChildren = array.filter(el => !el.parent_id);
    array = array.filter(el => el.parent_id);
    let count_item = 0;
    while (array.length && count_item < 30000) {count_item++;
        const arrayOfOthers = [];
        for (let i = 0; i < array.length; i++) {
            const elem = findChildren(arrayWithChildren, array[i].parent_id);
            if (elem) {
                if (!elem.children)
                    elem.children = [];
                elem.children.push(array[i]);
            } else {
                arrayOfOthers.push(array[i]);
            }
        }
        array = arrayOfOthers;
    }
    return arrayWithChildren;
}

const findChildren = (array, id) => {
    if (!array || !array.length)
        return null;
    const elem = array.find(el => el.id === id);
    if (elem)
        return elem;
    for (let i = 0; i < array.length; i++) {
        const elem = findChildren(array[i].children, id);
        if (elem)
            return elem;
    }
    return null;
}

const Access = ({
    setIsChange = () => {}
}) => {
    const { id: surveyId } = useParams();
    const addAlert = useAddAlert();

    //const [isOpen, setIsOpen] = useState(false);

    const [roles, setRoles] = useState([]);//роли
    const [departments, setDepartments] = useState([]);//отделы
    const [teams, setTeams] = useState([]);//команды
    const [classes, setClasses] = useState([]);//классы
    const [directions, setDirections] = useState([]);//направления

    const [arrayNames, setArrayNames] = useState([]);
    const [arrayValues, setArrayValues] = useState([[], [], [], [], []]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setArrayNames([
            {
                name: 'Роли',
                children: roles
            },
            {
                name: 'Отделы',
                children: departments
            },
            {
                name: 'Команды',
                children: teams
            },
            {
                name: 'Учащиеся Классов/Обр. траекторий',
                children: classes
            },
            {
                name: 'Учащиеся курсов',
                children: directions
            }
        ]);
    }, [roles, departments, teams, classes, directions]);
    useEffect(() => {
        rolesOrder.getList()
            .then(({data, status}) => {
                if (status !== 200) {
                    addAlert({ title: 'Ошибка', text: 'При загрузке ролей произошла ошибка', type: 'error' })
                    return;
                }
                setRoles(getArrayWithChildren(data));
                return data;
            })
            .then(rolesArray => {
                surveyApi.getAccess(surveyId).then(res => {
                    if (res.status === 200) {
                        setArrayValues([
                            res.data.data.available_for_roles.map(el => rolesArray.find(role => role.role == el).id),
                            res.data.data.available_for_units,
                            res.data.data.available_for_teams,
                            res.data.data.available_for_classes,
                            res.data.data.available_for_directions
                        ]);
                        setLoading(false);
                    }
                })
            });

        departmentsApi.getAll()
            .then(({data, status}) => {
                if (status !== 200) {
                    addAlert({ title: 'Ошибка', text: 'При загрузке отделов произошла ошибка', type: 'error' })
                    return;
                }
                setDepartments(getArrayWithChildren(data))
            });

      
        teamsApi.getAll()
            .then(({data, status}) => {
                if (status !== 200) {
                    addAlert({ title: 'Ошибка', text: 'При загрузке команд произошла ошибка', type: 'error' })
                    return;
                }
                setTeams(getArrayWithChildren(data))
            });
        
        classApi.index()
            .then(({data, status}) => {
                if (status !== 200) {
                    addAlert({ title: 'Ошибка', text: 'При загрузке классов произошла ошибка', type: 'error' })
                    return;
                }
                setClasses(getArrayWithChildren(data.data.map(el => ({ ...el, name: el.title }))))
            });

        directionAPI.getAll()
            .then(({data, status}) => {
                if (status !== 200) {
                    addAlert({ title: 'Ошибка', text: 'При загрузке направлений произошла ошибка', type: 'error' })
                    return;
                }
                setDirections(getArrayWithChildren(data.data?.map((el) => ({id: el.id, name: el.name}))))
            });

        
    }, []);

    /*const openList = () => {
        setIsOpen(true);
    }*/

    const [loadingSave, setLoadingSave] = useState(false);

    const save = () => {
        setLoadingSave(true);
        surveyApi.saveAccess({
            "survey_id": surveyId,
            "available_for_roles": arrayValues[0].map(el => roles.find(role => role.id === el).role),
            "available_for_units": arrayValues[1],
            "available_for_teams": arrayValues[2],
            "available_for_directions": arrayValues[4],
            "available_for_classes": arrayValues[3]
        }).then(res=> {
            if (res.status === 200) {
                setIsChange(false);
                addAlert({ title: '', text: 'Доступы успешно сохранены' })
            } else {
                addAlert({ title: 'Ошибка', text: 'Не удалось сохранить изменения', type: 'error' })
            }
            setLoadingSave(false);
        })
    }

    const [search, setSearch] = useState('');
    const [userLoading, setUserLoading] = useState(false);
    const [surveyUsers, setSurveyUsers] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);
    useEffect(() => {
        surveyApi.getUsers(surveyId).then(res => {
            if (res.status === 200) {
                setSurveyUsers(res.data.data);
                setTableLoading(false);
            }
        })
    }, []);
    const [users, setUsers] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    useEffect(() => {    
        if(typeof search === 'string' && search?.length > 2){
            setSearchLoading(true);
            usersAPI.getUsersCancel({
                    filter: [`[search]=${search}`, `[status]=10`],
                    'per-page': 50,
                    'page': 1,
            }).then(res => {
                if (res.status === 200) {
                    setUsers(res.data.data);
                    
                }
                setSearchLoading(false);
            })
        }
    }, [search]);

    const setTableValue = (id) => {
        setSurveyUsers(users => users.filter(el => el.id != id));
        surveyApi.saveUser({
            survey_id: surveyId,
            user_id: id
        })
    }

    return (<>
        { !loading && <Block>
            <div className={s.accessBlock/*classNames({[s.accessBlock]: isOpen})*/}>
                <OpenItem
                    //openList={openList}
                    arrayNames={arrayNames}
                    arrayValues={arrayValues}
                    //isOpen={isOpen}
                    setArrayValues={setArrayValues}
                    setIsChange={setIsChange}
                />
            </div>
            <SaveButton loading={loadingSave} save={save} />
        </Block>}
        { loading && <Preloader />}
        <div className={s.info}>
            Введите минимум 3 буквы для поиска сотрудников/учащихся и нажмите enter
        </div>
        <Search
            className={classNames(s.search, 'searchNewDesign', 'backgroundNone')}
            {...{search, setSearch}} />
        { search && <div className={s.users}>
            {(!userLoading && !searchLoading) && users.map((user, i) =>
                <div className={s.searchItem} key={user.id}>
                    <CheckboxViolet
                        text={<>
                            <span style={{ color: '#555'}}>{user.email}</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {user.name}
                        </>}
                        value={surveyUsers.some(el => el.id === user.id)}
                        setValue={(value) => {
                            setUserLoading(true);
                            surveyApi.saveUser({
                                survey_id: surveyId,
                                user_id: user.id
                            })
                            .then(res => {
                                if (res.status === 200) {
                                    let data = res.data.data.available_for_extra_users;
                                    if (!Array.isArray(data))
                                        data = Object.values(data);
                                    if (data.includes(user.id)) {
                                        if (!surveyUsers.find(el => el.id === user.id))
                                            setSurveyUsers(users => users.concat(user));
                                    } else {
                                        setSurveyUsers(users => users.filter(el => el.id != user.id));
                                    }
                                    setUserLoading(false);
                                }
                            });
                        }}
                        blockClassName={s.checkboxBlock}
                        textClassName={s.checkboxText1}
                        takePassedValue={true}
                    />
                </div>
            )}
            { (searchLoading || userLoading) && <Preloader />}
        </div>
        }
        { !tableLoading &&
            <Table state={surveyUsers.map(el => el).sort((el1, el2) => el1.name.localeCompare(el2.name))} setValue={setTableValue} />
        }
        { tableLoading && <Preloader />}
    </>)
}

export const OpenItem = ({
    arrayNames,
    arrayValues,
    //openList,
    isOpen = true,
    categoryNumber,
    setArrayValues,
    setIsChange = () => {}
}) => {

    const [openChildren, setOpenChildren] = useState([]);
    return (<>
        { //!isOpen &&
            arrayNames.map((el, i) =>
                (<div key={i} className={s.itemBlock}>
                    <div className={classNames(/*{[s.openItem]: isOpen}, {[s.item]: !isOpen}*/s.openItem, {[s.noBorder]: (i === arrayNames.length - 1) && !openChildren.includes(i)})}>
                        { (categoryNumber !== undefined && el.id) ? <CheckboxViolet
                            text={el.name}
                            value={arrayValues.includes(el.id)}
                            onClickCheckbox={(value) => {
                                setArrayValues(arrayValues => arrayValues.map((category, categoryIndex) =>
                                    (categoryIndex === categoryNumber) ?
                                    (value ? category.concat(el.id) : category.filter(categoryItem => categoryItem !== el.id)) :
                                    category
                                ));
                                setIsChange(true);
                            }}
                            onClickText={() => {
                                if (el.children?.length)
                                    setOpenChildren(openChildren => openChildren.includes(i) ? openChildren.filter(el => el !== i) : openChildren.concat(i))
                            }}
                            blockClassName={s.checkboxBlock}
                            textClassName={classNames({[s.checkboxText1]: !isOpen}, {[s.checkboxText2]: isOpen})}
                        /> : ''}
                        { ((categoryNumber === undefined) || !el.id) && 
                            <div className={classNames({[s.checkboxText1]: !isOpen}, {[s.checkboxText2]: isOpen})}
                                onClick={() => {
                                    if (el.children?.length)
                                        setOpenChildren(openChildren => openChildren.includes(i) ? openChildren.filter(el => el !== i) : openChildren.concat(i))
                                    }
                                }
                            >
                                {el.name}
                            </div>
                        }
                        { el?.children && el.children.length > 0 && <img
                            src={arrowSelectRight}
                            alt="расскрыть пункты"
                            className={classNames(s.arrowSelectRight, {[s.arrowSelectBottom]: openChildren.includes(i)})}
                            onClick={() => {
                                //if (!isOpen) openList();
                                setOpenChildren(openChildren => openChildren.includes(i) ? openChildren.filter(el => el !== i) : openChildren.concat(i))
                            }}
                        />}
                    </div>
                    { openChildren.includes(i) &&
                        <div className={s.margin}>
                            <OpenItem
                                //openList={openList}
                                arrayNames={el.children}
                                isOpen={isOpen}
                                categoryNumber={categoryNumber ? categoryNumber : i}
                                arrayValues={categoryNumber ? arrayValues : arrayValues[i]}
                                setArrayValues={setArrayValues}
                                setIsChange={setIsChange}
                            />
                        </div>
                    }
                </div>
            ))
        }
    </>)
}

export default Access;